<template>
  <Container
    wide
    padding=" w-full p-0 mb-20"
  >
    <ColumnWrapper class="justify-center gap-4">
      <!-- <LeftColumn
        small
        class="pr-4"
      >
        <FeedSortContainer :company="company" />
      </LeftColumn> -->
      <MiddleColumn>
        <div class="w-full">
          <div
            v-if="loading"
            class="w-full flex justify-center p-8"
          >
            <CircleLoader />
          </div>
          <template v-else>
            <WritePostModalContainer :company-id="company.id" />
            <PostsContainer
              company-feed
              is-inside-company
              :show-post-menu="showPostMenu"
              @show-post-menu-modal="showPostMenu = $event"
            />
          </template>
        </div>
      </MiddleColumn>
      <RightColumn
        small
        class="flex-grow-0"
      >
        <PressReleaseWidgetContainer
          type="views"
          order-by="views"
          :company="company"
          :range="730"
        >
          {{ $t('Trending News') }}
        </PressReleaseWidgetContainer>
        <!-- <MentionsTemperatureContainer
          class="mt-4"
          :company-id="company.id"
        /> -->
      </RightColumn>
    </ColumnWrapper>
  </Container>
</template>

<script>

import PostsContainer from '@/modules/posts'
// import FeedSortContainer from '@/modules/feedSort/'
import WritePostModalContainer from '@/modules/writePostModal'
import PressReleaseWidgetContainer from '@/modules/pressReleaseWidget'
// import MentionsTemperatureContainer from '@/modules/mentionsTemperature'
import { useCompaniesStore } from '../../stores/companies'

export default {
  name: 'CompanyDiscussionsModule',
  components: {
    PostsContainer,
    // FeedSortContainer,
    WritePostModalContainer,
    PressReleaseWidgetContainer,
    // MentionsTemperatureContainer
  },
  setup() {
  const companiesStore = useCompaniesStore()
  
  return { companiesStore }
},
data () {
        return {
        showPostMenu: false,
      
        }
    },
  computed: {
    company() {
      return this.companiesStore.selectedCompany
    },
    loading() {
      return this.companiesStore.loading
    }
  }
}
</script>
